export const QUERY_KEYS = {
	CONSULT_PROTOCOLS: 'CONSULT_PROTOCOLS',
	GET_CURRENT_REFERRALS: 'GET_CURRENT_REFERRALS',
	GET_PAST_REFERRALS: 'GET_PAST_REFERRALS',
	GET_REFERRAL_DETAILS: 'GET_REFERRAL_DETAILS',
	FEATURE_FLAGS: 'FEATURE_FLAGS',
	FRANCHISES_TABLE: 'FRANCHISES_TABLE',
	CREATE_TOKEN: 'CREATE_TOKEN',
	OPEN_BILLS: 'OPEN_BILLS',
	OPEN_BILLS_INVOICES: 'OPEN_BILLS_INVOICES',
	ADHERENCE_DIGITAL_PAYMENT: 'ADHERENCE_DIGITAL_PAYMENT',
	SAO_LUCAS_BILLS: 'SAO_LUCAS_BILLS',
	HISTORY_YEARS: 'HISTORY_YEARS',
	OBLIGATION_HISTORY: 'OBLIGATION_HISTORY',
	OBLIGATION_PDF: 'OBLIGATION_PDF',
	INCOME_TAX_DETAILS: 'INCOME_TAX_DETAILS',
	INCOME_TAX_PDF: 'INCOME_TAX_PDF',
	COPARTICIPATION_EXTRACT: 'COPARTICIPATION_EXTRACT',
	COPARTICIPATION_EXTRACT_PDF: 'COPARTICIPATION_EXTRACT_PDF',
	LIFEPLACE_LINK: 'LIFEPLACE_LINK',
	LIFEPLACE_PRODUCTS: 'LIFEPLACE_PRODUCTS',
	CONTACT_DATA: 'CONTACT_DATA',
	WOMEN_CHANNEL_URL: 'WOMEN_CHANNEL_URL',
	FAQ_URL: 'FAQ_URL',
	HEALTH_CARD: 'HEALTH_CARD',
	ADDRESS_BY_ZIP_CODE: 'ADDRESS_BY_ZIP_CODE',
	REVERSE_GEOCODE: 'REVERSE_GEOCODE',
	EXAMS_PREPARATION: 'EXAMS_PREPARATION',
	HEALTH_APPOINTMENTS_HISTORY: 'HEALTH_APPOINTMENTS_HISTORY',
	APPOINTMENTS_TELEHEALTH_DOCS: 'APPOINTMENTS_TELEHEALTH_DOCS',
	FORGOT_PASSWORD_DATA: 'FORGOT_PASSWORD_DATA',
	RESEND_TIMER: 'RESEND_TIMER',
	UF_GUIDE: 'UF_GUIDE',
	CITIES_GUIDE: 'CITIES_GUIDE',
	SERVICES_GUIDE: 'SERVICES_GUIDE',
	HEALTH_SPECIALTIES_GUIDE: 'HEALTH_SPECIALTIES_GUIDE',
	ODONTO_SPECIALTIES_GUIDE: 'ODONTO_SPECIALTIES_GUIDE',
	DISTRICTS_GUIDE: 'DISTRICTS_GUIDE',
	HEALTH_DISTRICTS_GUIDE: 'HEALTH_DISTRICTS_GUIDE',
	NETWORK_FILTERS_GUIDE: 'NETWORK_FILTERS_GUIDE',
	HEALTH_PROVIDERS_GUIDE: 'HEALTH_PROVIDERS_GUIDE',
	HEALTH_PROCEDURE_DATA: 'HEALTH_PROCEDURE_DATA',
	HEALTH_PROVIDER_DETAILS_GUIDE: 'HEALTH_PROVIDER_DETAILS_GUIDE',
	ODONTO_PROVIDERS_GUIDE: 'ODONTO_PROVIDERS_GUIDE',
	ODONTO_PROVIDER_DETAILS_GUIDE: 'ODONTO_PROVIDER_DETAILS_GUIDE',
	CITY_LOCATION_GUIDE: 'CITY_LOCATION_GUIDE',
	SEARCH_PROCEDURE_GUIDE: 'SEARCH_PROCEDURE_GUIDE',
	HEALTH_GUIDE_FAVORITE_PLACES: 'HEALTH_GUIDE_FAVORITE_PLACES',
	PROFILE_FAVORITE_ADDRESSES: 'PROFILE_FAVORITE_ADDRESSES',
	HEALTH_GUIDE_FAVORITE_DOCTORS: 'HEALTH_GUIDE_FAVORITE_DOCTORS',
	HOME: 'HOME',
	GET_COMMUNICATIONS: 'GET_COMMUNICATIONS',
	BANNERS: 'BANNERS',
	AUTHORIZATIONS: 'AUTHORIZATIONS',
	AUTHORIZATIONS_REQUESTS: 'AUTHORIZATIONS_REQUESTS',
	AUTHORIZATIONS_ODONTO: 'AUTHORIZATIONS_ODONTO',
	AUTHORIZATIONS_ODONTO_TRACK: 'AUTHORIZATIONS_ODONTO_TRACK',
	AUTOSOL_PRINT_GUIDE: 'AUTOSOL_PRINT_GUIDE',
	AUTOSOL_DENIAL_LETTER: 'AUTOSOL_DENIAL_LETTER',
	AUTOSOL_DENIAL_LETTER_ODONTO: 'AUTOSOL_DENIAL_LETTER_ODONTO',
	CONCIERGE_URL: 'CONCIERGE_URL',
	AUTOSOL_REQUEST_DETAILS: 'AUTOSOL_REQUEST_DETAILS',
	AUTOSOL_RECOVER_FILE: 'AUTOSOL_RECOVER_FILE',
	AUTH_SCHEDULE: 'AUTH_SCHEDULE',
	AUTOSOL_REQUEST_PROVIDERS_LIST: 'AUTOSOL_REQUEST_PROVIDERS_LIST',
	BENEFICIARY_BANK_DATA: 'BENEFICIARY_BANK_DATA',
	REFUND_BANKS: 'REFUND_BANKS',
	VALIDATE_REFUND_BANK: 'VALIDATE_REFUND_BANK',
	PLANS: 'PLANS',
	BENEFICIARIES: 'BENEFICIARIES',
	WELL_BORN_ELIGIBILITY: 'WELL_BORN_ELIGIBILITY',
	B2B_BENEFICIARY_STATUS: 'B2B_BENEFICIARY_STATUS',
	EXAM_RESULTS: 'EXAM_RESULTS',
	EXAM_REQUEST_REPORTS: 'EXAM_REQUEST_REPORTS',
	CONSULT_REFUND_PROTOCOL_STATUS: 'CONSULT_REFUND_PROTOCOL_STATUS',
	RESEND_TOKEN_DATA: 'RESEND_TOKEN_DATA',
	HOSPITALIZATION_OPINIONS_LIST: 'HOSPITALIZATION_OPINIONS_LIST',
	HOSPITALIZATION_PATIENT_DATA: 'HOSPITALIZATION_PATIENT_DATA',
	HOSPITALIZATION_EXAMS_LIST: 'HOSPITALIZATION_EXAMS_LIST',
	HOSPITALIZATION_DOCTOR_VISITS_LIST: 'HOSPITALIZATION_DOCTOR_VISITS_LIST',
	HOSPITALIZATION_PROCEDURES_LIST: 'HOSPITALIZATION_PROCEDURES_LIST',
	HOSPITALIZATION_PRESCRIPTIONS_LIST: 'HOSPITALIZATION_PRESCRIPTIONS_LIST',
	CITIES_BY_FLOW: 'CITIES_BY_FLOW',
	CITIES_BY_FLOW_V1: 'CITIES_BY_FLOW_V1',
	STATE_BY_FLOW: 'STATE_BY_FLOW',
	STATE_BY_FLOW_V1: 'STATE_BY_FLOW_V1',
	REFUND_STATES: 'REFUND_STATES',
	REFUND_PROCEDURE_THERAPIES: 'REFUND_PROCEDURE_THERAPIES',
	REFUND_CITIES: 'REFUND_CITIES',
	REFUND_MODALITIES: 'REFUND_MODALITIES',
	REFUND_PROFESSIONAL_COUNCILS: 'REFUND_PROFESSIONAL_COUNCILS',
	REFUND_BENEFICIARIES: 'REFUND_BENEFICIARIES',
	REFUND_PLANS: 'REFUND_PLANS',
	REFUND_CONSULT: 'REFUND_CONSULT',
	REFUND_CONSULT_PREVIEW: 'REFUND_CONSULT_PREVIEW',
	REFUND_PREVIEW_PROCEDURE_SEARCH: 'REFUND_PREVIEW_PROCEDURE_SEARCH',
	CONTENT: 'CONTENT',
	LOCALITIES: 'LOCALITIES',
	DISTRICTS_HEALTH: 'DISTRICTS_HEALTH',
	DISTRICTS_EXAMS: 'DISTRICTS_EXAMS',
	DISTRICTS_ODONTO: 'DISTRICTS_ODONTO',
	CITY_LOCATION_AND_VERIFY_SPECIALTIES: 'CITY_LOCATION_AND_VERIFY_SPECIALTIES',
	OUR_DOCTOR_MESSAGE: 'OUR_DOCTOR_MESSAGE',
	HEALTH_SPECIALTY_DESCRIPTION: 'HEALTH_SPECIALTY_DESCRIPTION',
	FIVE_STARS: 'FIVE_STARS',
	PROGRESS_PROFILE: 'PROGRESS_PROFILE',
	ACCESS_MANAGEMENT_FEATURES: 'ACCESS_MANAGEMENT_FEATURES',
	ACCESS_MANAGEMENT_PERMISSIONS: 'ACCESS_MANAGEMENT_PERMISSIONS',
	EXAMS_LIST: 'EXAMS_LIST',
	EXAMS_UNITS: 'EXAMS_UNITS',
	EXAMS_DATES: 'EXAMS_DATES',
	EXAMS_AVAILABLE_TIMES: 'EXAMS_AVAILABLE_TIMES',
	HEALTH_PROVIDERS_NAME: 'HEALTH_PROVIDERS_NAME',
	HEALTH_DATES: 'HEALTH_DATES',
	HEALTH_SPECIALTIES: 'HEALTH_SPECIALTIES',
	HEALTH_UNITS: 'HEALTH_UNITS',
	HEALTH_UNITS_SUPPORT_ACCREDITED: 'HEALTH_UNITS_SUPPORT_ACCREDITED',
	HEALTH_PROVIDER_LOCATION_PREVIEW: 'HEALTH_PROVIDER_LOCATION_PREVIEW',
	HEALTH_AVAILABLE_TIMES: 'HEALTH_AVAILABLE_TIMES',
	REGISTRATION_UPDATE_STATUS: 'REGISTRATION_UPDATE_STATUS',
	ADDRESS_SUGGESTION: 'ADDRESS_SUGGESTION',
	ADDRESS_UPDATE_INDICATOR: 'ADDRESS_UPDATE_INDICATOR',
	ODONTO_DATES: 'ODONTO_DATES',
	ODONTO_SPECIALTIES: 'ODONTO_SPECIALTIES',
	ODONTO_AVAILABLE_TIMES: 'ODONTO_AVAILABLE_TIMES',
	APPOINTMENT_ATTACHMENTS: 'APPOINTMENT_ATTACHMENTS',
	CHANGE_DUE_DATE_OPTIONS: 'CHANGE_DUE_DATE_OPTIONS',
	CHANGE_DUE_DATE_PREVIEW: 'CHANGE_DUE_DATE_PREVIEW',
	CONTRACTUAL_TERM_PENDING: 'CONTRACTUAL_TERM_PENDING',
	CONGENERE_ELIGIBILITY: 'CONGENERE_ELIGIBILITY',
	SERVICE_POINTS_ADDRESSES: 'SERVICE_POINTS_ADDRESSES',
	SERVICE_POINTS_UFS: 'SERVICE_POINTS_UFS',
};
